import { render, staticRenderFns } from "./EditSharedBriefResource.vue?vue&type=template&id=4ca59444&scoped=true&"
import script from "./EditSharedBriefResource.vue?vue&type=script&lang=js&"
export * from "./EditSharedBriefResource.vue?vue&type=script&lang=js&"
import style0 from "./EditSharedBriefResource.vue?vue&type=style&index=0&id=4ca59444&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca59444",
  null
  
)

export default component.exports